// extracted by mini-css-extract-plugin
export default {"fields":"OrgPaymentModal-module--fields--Qv_0v","footer":"OrgPaymentModal-module--footer--cqI4E","deleteButton":"OrgPaymentModal-module--deleteButton--viSwe"};